import * as React from 'react';
import { prefixClassName } from 'framework/components/ui/_conf';
import './_styles.scss';

const clx = prefixClassName('stencil-form-field');

export const StencilText = () => (
  <div className={clx}>
    <div className={`${clx}__bg-masker ${clx}__top`} />
  </div>
);

export default StencilText;
